import type { IconSvgObject } from './types';

const ReturnRequestIcon: IconSvgObject = [
  ["path", { d: "M2 8V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.44721 3.10557L2 8H22L19.5528 3.10558C19.214 2.42801 18.5215 2 17.7639 2L6.23607 2C5.47852 2 4.786 2.428 4.44721 3.10557Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 8V2", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 14H14C15.1046 14 16 14.8954 16 16C16 17.1046 15.1046 18 14 18H13M10 12L8 14L10 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ReturnRequestIcon;
